import { QuoteBand } from '@/components/ui/QuoteBand'

export const ConsultationsTestimonial = () => (
  <QuoteBand
    quote="I learnt so much about women's health and natural remedies. Kandake is an amazing herbalist and teacher who ensures everyone truly understands."
    author="Jackie"
    role="Consultation Client"
  />
)
